<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-header-title">
      {{ 'EDIT_AMOUNT.APPLY_DISCOUNT' | fallbackTranslate }}
    </div>
    <div class="dialog-header-cross" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close"/>
    </div>
  </div>

  <nz-tabset nzTabBarGutter="1" nzSize="small">
    <ng-container *ngFor="let tab of tabsGroup">
      <nz-tab
        *ngIf="
        !(
          ((tab?.value === 'presets' && !isPresetEnabled)
           || (tab?.value === 'client_coupon' && !isClientCouponEnabled) )
           && (data?.source === 'order-details' || data?.source === 'pos-order')   
        )
        "
        [nzTitle]="tab?.label"
        (nzClick)="changeTab(tab?.value)"
      >
      <ng-container *ngIf="tab?.value != 'client_coupon'">
        <ng-container *ngTemplateOutlet="discountContainer"></ng-container>
      </ng-container>
      
      <ng-container *ngIf="tab?.value == 'client_coupon'">
        <ng-container *ngTemplateOutlet="clientCouponContainer"></ng-container>
      </ng-container>
      
      </nz-tab>
    </ng-container>
  </nz-tabset>

  <ng-template #discountContainer>
    <ng-container *ngIf="currentTab === 'presets'; else otherDiscountTypes">
      <ng-container *ngIf="allPresetCouponsList.length && !isLoading">
        <nz-input-group [nzPrefix]="prefixIconSearch">
          <input
            type="text"
            nz-input
            [(ngModel)]="searchFilter"
            (ngModelChange)="searchQueryChange($event)"
            [placeholder]="'PLACEHOLDERS.SEARCH_FOR_PRESET_DISCOUNT' | fallbackTranslate" />
        </nz-input-group>
        <ng-template #prefixIconSearch>
          <i class="fa fa-search" aria-hidden="true" style="opacity: 0.6"></i>
        </ng-template>
        <div class="discount-container">
          <label for="">
            {{ 'EDIT_AMOUNT.ADD_PRESENT_DISCOUNT' | fallbackTranslate }}
          </label>
          <div class="discount-card-grid" *ngIf="presetCouponList?.length">
            <ng-container *ngFor="let item of presetCouponList">
              <div
                class="discount-card flex-center"
                (click)="discountClicked(item)"
                [ngClass]="
                  selectedDiscount === item?.code
                    ? 'discount-card-selected'
                    : null
                "
              >
                {{ item?.code }}
              </div>
            </ng-container>
          </div>
          <ng-container *ngIf="presetCouponList?.length === 0">
            <div class="discount-container">
              <p nz-text nzType="secondary" class="m-10 ta_center fw-600">
                {{ 'EDIT_AMOUNT.NO_SEARCH_RESULT' | fallbackTranslate }}
              </p>
            </div>
          </ng-container>
        </div>

        <!-- <div class="discount-container">
          <label for="">Select Reason</label>
          <div class="discount-card-grid">
            <div
              class="discount-card flex-center"
              *ngFor="let reason of reasonPresets"
              (click)="reasonClicked(reason)"
              [ngClass]="
                selectedReason === reason?.label
                  ? 'discount-card-selected'
                  : null
              "
            >
              {{ reason?.label }}
            </div>
          </div>
        </div> -->
      </ng-container>

      <ng-container *ngIf="allPresetCouponsList.length === 0 && !isLoading">
        <nz-empty [nzNotFoundContent]="contentCustom">
          <ng-template #contentCustom>
            <span>{{ 'EDIT_AMOUNT.NO_COUPONS' | fallbackTranslate }}</span>
          </ng-template>
        </nz-empty>
      </ng-container>

      <nz-skeleton [nzActive]="true" *ngIf="isLoading"></nz-skeleton>
    </ng-container>

    <ng-template #otherDiscountTypes>
      <div class="discount-container">
        <label for="">
          {{ 'EDIT_AMOUNT.SELECT_DISCOUNT_AMOUNT' | fallbackTranslate }}
        </label>
        <div class="discount-card-grid">
          <div
            class="discount-card flex-center"
            *ngFor="
              let item of this.currentTab === 'flat'
                ? this.flatDiscount
                : this.currentTab === 'percentage'
                ? this.percentageDiscount
                : this.flatTopup
            "
            (click)="discountClicked(item)"
            [ngClass]="
              selectedDiscount === item?.name ? 'discount-card-selected' : null
            "
          >
            {{ item?.name }}
          </div>

          <div
            class="discount-card-input-box c-pointer"
            (click)="discountClicked({ name: 'custom_discount' })"
            [ngClass]="
              selectedDiscount === 'custom_discount'
                ? 'discount-card-selected'
                : null
            "
            nz-popover
            nzPopoverTrigger="click"
            nzPopoverPlacement="right"
            [nzPopoverContent]="virtualKeyboard"
          >
            <span class="prefix">
              {{
                this.currentTab === 'flat'
                  ? '-' + Currency
                  : this.currentTab === 'percentage'
                  ? '%'
                  : '+' + Currency
              }}
            </span>
            <input
              type="text"
              #customInput
              [(ngModel)]="customDiscountValue"
              (keypress)="inputChanges($event)"
              inputmode="none"
              placeholder="{{'PLACEHOLDERS.ENTER_DISCOUNT_VALUES' | fallbackTranslate}}"
            />
          </div>
        </div>
      </div>

      <div class="discount-container">
        <label for="">{{ 'EDIT_AMOUNT.SELECT_REASON' | fallbackTranslate }}</label>
        <div class="discount-card-grid">
          <div
            class="discount-card flex-center"
            *ngFor="
              let reason of reasonPresets
            "
            (click)="reasonClicked(reason)"
            [ngClass]="
              selectedReason === reason?.label ? 'discount-card-selected' : null
            "
          >
            {{ reason?.label }}
          </div>
          <div
            class="discount-card-input-box c-pointer"
            (click)="reasonClicked({ label: 'other_reason' })"
            [ngClass]="
              selectedReason === 'other_reason'
                ? 'discount-card-selected'
                : null
            "
          >
            <input
              type="text"
              [(ngModel)]="customReason"
              maxlength="30"
              placeholder="{{ 'PLACEHOLDERS.ENTER_OTHER_REASONS' | fallbackTranslate }}"
            />
          </div>
        </div>
      </div>
    </ng-template>
  </ng-template>

  <ng-template #clientCouponContainer>
    <div class="discount-container">
      <label for="">
        {{ 'EDIT_AMOUNT.ENTER_CLIENT_COUPON' | fallbackTranslate }}
      </label>
    </div>
    <input
      type="text"
      nz-input
      [(ngModel)]="clientCouponCode"
      [placeholder]="'EDIT_AMOUNT.ENTER_CLIENT_COUPON' | fallbackTranslate"
     />
  </ng-template>

  <div class="dialog-footer">
    <button
      class="save"
      [disabled]="
        currentTab === 'presets' &&
        allPresetCouponsList.length === 0 &&
        !isLoading
      "
      (click)="submit()"
    >
      {{ 'EDIT_AMOUNT.APPLY' | fallbackTranslate }}
    </button>
  </div>
</div>

<ng-template #virtualKeyboard>
  <app-virtual-keyboard
    [showTripleZeros]="currentTab !== 'percentage'"
    (numberEntered)="getNumber($event)"
    (numBackClicked)="numBack($event)"
    (decimalClicked)="getDecimal($event)"
  ></app-virtual-keyboard>
</ng-template>
